/**
 * Enum error code
 */
export enum ErrorCode {
	ERR_UNKNOWN_001 = "ERR_UNKNOWN_001",
	ERR_BIOMETRY_001 = "ERR_BIOMETRY_001",
	ERR_FRAUD_ANALYSIS_001 = "ERR_FRAUD_ANALYSIS_001",
	ERR_FRAUD_ANALYSIS_002 = "ERR_FRAUD_ANALYSIS_002",
	ERR_TOKEN_001 = "ERR_TOKEN_001",
	ERR_BALANCE_INQUIRY_001 = "ERR_BALANCE_INQUIRY_001",
	ERR_CONTRACTS_ELIGIBLE_001 = "ERR_CONTRACTS_ELIGIBLE_001",
	ERR_PARTIAL_SIMULATION_001 = "ERR_PARTIAL_SIMULATION_001",
	ERR_TOTAL_SIMULATION_001 = "ERR_TOTAL_SIMULATION_001",
	ERR_FULL_REGISTRATION_001 = "ERR_FULL_REGISTRATION_001",
	ERR_PERSONAL_OTP_001 = "ERR_PERSONAL_OTP_001",
	ERR_PERSONAL_ADDRESS_001 = "ERR_PERSONAL_ADDRESS_001",
	ERR_PERSONAL_OTP_VALIDATE_001 = "ERR_PERSONAL_OTP_VALIDATE_001",
	ERR_PERSONAL_PASSWORD_001 = "ERR_PERSONAL_PASSWORD_001",
	ERR_PERSONAL_001 = "ERR_PERSONAL_001",
	ERR_PERSONAL_CONTACTS_PHONES_001 = "ERR_PERSONAL_CONTACTS_PHONES_001",
	ERR_PERSONAL_CONTACTS_EMAILS_001 = "ERR_PERSONAL_CONTACTS_EMAILS_001",
	ERR_PERSONAL_POSTAL_ADDRESSES_001 = "ERR_PERSONAL_POSTAL_ADDRESSES_001",
	ERR_PERSONAL_FILIATION_001 = "ERR_PERSONAL_FILIATION_001",
	ERR_ALREADY_REGISTRATION_001 = "ERR_ALREADY_REGISTRATION_001",
	ERR_PERSONAL_PASSWORD_VALIDATE_001 = "ERR_PERSONAL_PASSWORD_VALIDATE_001",
	ERR_CONTRACTS_SIGNED_001 = "ERR_CONTRACTS_SIGNED_001",
	ERR_FINANCIAL_TERMS_CONSENTS_001 = "ERR_FINANCIAL_TERMS_CONSENTS_001",
	ERR_PASSWORD_001 = "ERR_PASSWORD_001",
}
